/**
 * Performs a top-level browser navigation to the given URL.
 *
 * Wraps `window.location.assign` in a small, mockable seam so components can be
 * unit-tested without touching the (non-configurable, read-only) `window.location`
 * global, which cannot be redefined or spied on under modern jsdom.
 *
 * @param {string} url - The absolute URL to navigate to.
 */
const redirect = (url) => {
  window.location.assign(url)
}

export default redirect
